import React from 'react';
import { bool } from 'prop-types';

import { PromoProgressMessage } from './subcomponents/PromoProgressMessage/PromoProgressMessage';
import { PromoProgressBar } from '../promo-progress-bar/PromoProgressBar';
import './PromoProgress.scss';

export const PromoProgress = ({ isInPromoDrawer }) => {
  return (
    <div className="promo-progress">
      <PromoProgressMessage isInPromoDrawer={isInPromoDrawer} />
      <PromoProgressBar />
    </div>
  );
};

PromoProgress.displayName = 'PromoProgress';

PromoProgress.propTypes = {
  isInPromoDrawer: bool,
};

PromoProgress.defaultProps = {
  isInPromoDrawer: false,
};
